import ContentComponent from './Content/Content'
import SidebarComponent from './Sidebar/Sidebar'
import WrapperComponent from './Wrapper/Wrapper'

export const Content = ContentComponent
export const Sidebar = SidebarComponent
export const Wrapper = WrapperComponent
